/**
 * Centralized route definitions.
 */ export const BRAND_NAME = 'Elevated';
export const ROUTES = {
    home: '/',
    login: '/login',
    shop: '/shop',
    product: '/shop/:slug',
    about: '/about',
    contact: '/contact',
    cart: '/cart',
    checkout: '/checkout',
    checkoutConfirmation: '/checkout/confirmation',
    accountOrders: '/account/orders',
    orderDetail: '/account/orders/:orderId',
    orderLookup: '/order-lookup',
    admin: '/admin',
    adminProducts: '/admin/products',
    adminProductNew: '/admin/products/new',
    adminProductEdit: '/admin/products/:productId',
    adminOrders: '/admin/orders',
    adminWholesalers: '/admin/wholesalers'
};
export const PATHS = {
    shop: 'shop',
    product: 'shop/:slug',
    about: 'about',
    contact: 'contact',
    cart: 'cart',
    checkout: 'checkout',
    checkoutConfirmation: 'checkout/confirmation',
    accountOrders: 'account/orders',
    orderDetail: 'account/orders/:orderId',
    orderLookup: 'order-lookup',
    admin: 'admin',
    adminProducts: 'admin/products',
    adminProductNew: 'admin/products/new',
    adminProductEdit: 'admin/products/:productId',
    adminOrders: 'admin/orders',
    adminWholesalers: 'admin/wholesalers'
};
